import FJVoiceCloneEdit from '../view/FJVoiceCloneEdit.jsx';
import FJModal from '../../FJModal/index.jsx';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import FJActionVoiceCloning from '../../../../redux/action/FJActionVoiceCloning.js';

const FJVoiceCloneEditContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const isShowVoiceEditModal = useSelector(state => state.voiceCloning.isShowVoiceEditModal);
    const voiceCloneEditProfileId = useSelector(state => state.voiceCloning.voiceCloneEditProfileId);
    const voiceCloneEditName = useSelector(state => state.voiceCloning.voiceCloneEditName);

    const _onClose = () => {
        dispatch(FJActionVoiceCloning.hideVoiceCloneEditAction());
    };

    const _onChangeProfile = profileId => {
        dispatch(FJActionVoiceCloning.setVoiceCloneEditProfileIdAction(profileId));
    };

    const _onChangeVoiceName = value => {
        dispatch(FJActionVoiceCloning.setVoiceCloneEditNameAction(value));
    };

    const _editInfo = () => {
        dispatch(FJActionVoiceCloning.editVoiceCloneInfoAction());
    };

    return (
        <FJModal visible={isShowVoiceEditModal}>
            <FJVoiceCloneEdit
                onClose={_onClose}
                profileId={voiceCloneEditProfileId}
                name={voiceCloneEditName}
                onChangeProfile={_onChangeProfile}
                onChangeVoiceName={_onChangeVoiceName}
                editInfo={_editInfo}
            />
        </FJModal>
    );
};

export default FJVoiceCloneEditContainer;
